import * as React from 'react';
import { useState, useEffect } from 'react';
import styles from './register.module.scss';

import icon_doctor from '../static/images_pfizer/register_doctor.png';
import icon_assistant from '../static/images_pfizer/register_assistant.png';
import icon_patient from '../static/images_pfizer/register_patient.png';
import right_icon from '../static/images_pfizer/right_icon.png';
import { Toast } from 'antd-mobile';

import { ApiCore } from '../api/index';
import utils from '../utils/utils';
const api = new ApiCore();


const PfizerRegister = () => {


    // 小程序url
    const [doctorUrlScheme, setDoctorUrlScheme] = useState<any>('');
    const [patientUrlScheme, setPatientUrlScheme] = useState<any>('');
    const [assistantUrlScheme, setAssistantUrlScheme] = useState<any>('');
    const [wxMiniEnv, setWxMiniEnv] = useState<any>('');
    const [groupCode, setGroupCode] = useState<any>('');

    useEffect(() => {
        document.title = '案例上传';
        initUrlData();
        initEnv();
        // getUrlScheme()
    }, [])

    /**
     * 小程序环境设置
     */
     const initUrlData = () => {
        const _urlParam = utils.getUrlParams() || {};
        if (_urlParam.groupCode) {
            setGroupCode(_urlParam.groupCode);
        }
    }

    /**
     * 小程序环境设置
     */
    const initEnv = () => {
        let env = process.env.REACT_APP_ENV;
        let envVersion = 'release';
        // 开发环境 开发版
        if (env === 'development') {
            envVersion = 'develop';
        }
        // 测试环境 体验版
        else if (env === 'test') {
            envVersion = 'trial';
        }
        // 生产环境 正式版
        else if (env === 'production') {
            envVersion = 'release';
        }
        setWxMiniEnv(envVersion);
    }

    /**
     * 生成小程序url scheme
     */
    const getUrlScheme = (role = '') => {
        return new Promise<string>((resolve, reject) => {
            let wxminiUrlPath = '';
            if (role === 'doctor') {
                if (doctorUrlScheme) {
                    resolve(doctorUrlScheme);
                    return;
                }
                wxminiUrlPath = 'pages/doctor/doctor';
            } else if (role === 'assistant') {
                if (assistantUrlScheme) {
                    resolve(assistantUrlScheme);
                    return;
                }
                wxminiUrlPath = 'pages/assistant/assistant';
            } else if (role === 'patient') {
                if (patientUrlScheme) {
                    resolve(patientUrlScheme);
                    return;
                }
                wxminiUrlPath = 'pages/patient/patient';
            }
            let params = {
                appCode: 'APP001',
                envVersion: wxMiniEnv,
                path: wxminiUrlPath,
                query: '&groupCode=' + groupCode
            }
            api.getAppSecretScheme(params).then((res: any) => {
                if (res.code == 0) {
                    if (!res.data) {
                        Toast.fail(res.message || '获取小程序链接失败', 0.8);
                        return
                    }
                    if (role === 'doctor') {
                        setDoctorUrlScheme(res.data);
                    } else if (role === 'assistant') {
                        setAssistantUrlScheme(res.data);
                    } else if (role === 'patient') {
                        setPatientUrlScheme(res.data);
                    }
                    resolve(res.data);
                }
            });
        })
    }

   /**
     * 生成链接并跳转
     */
    const registerUrlAndJump = (role = '') => {
        getUrlScheme(role).then(url => {
            if (url) {
                window.location.href = url;
            }
        });
    }

    return (
        <div className={styles.register_content}>
            <div className={styles.header}>
                <div className={styles.title_content}>
                    <div className={styles.title}>选择要注册的角色</div>
                    <div className={styles.info}>根据您的个人情况，选择要注册的角色</div>
                </div>
            </div>

            <div className={styles.register_type} onClick={() => { registerUrlAndJump('doctor') }}>
                <div className={styles.leftCon}>
                    <img src={icon_doctor} alt="" />
                    <div>注册成为医生</div>
                </div>
                <div> <img className={styles.right_icon} src={right_icon} alt="" /> </div>
            </div>
            <div className={styles.register_type} onClick={() => { registerUrlAndJump('assistant') }}>
                <div className={styles.leftCon}>
                    <img className={styles.assistant} src={icon_assistant} alt="" />
                    <div>注册成为医助</div>
                </div>
                <div> <img className={styles.right_icon} src={right_icon} alt="" /> </div>
            </div>
            {/* <div className={styles.register_type} onClick={() => { registerUrlAndJump('patient') }}>
                <div className={styles.leftCon}>
                    <img className={styles.patient} src={icon_patient} alt="" />
                    <div>注册成为患者</div>
                </div>
                <div> <img className={styles.right_icon} src={right_icon} alt="" /> </div>
            </div> */}
        </div>
    )
}

export default PfizerRegister